/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { Button, dayjs, Drawer, Message, Pagination, Table, TableColumn } from '@king-design/react'
import { copyScene, SceneRecordItemProp } from '../container'
import { getStatus } from '../../Trigger/container'
import { useAsync } from 'react-use'
import { UserInfo } from 'src/components'
import { useHistory } from 'react-router-dom'
import { getSceneList } from 'src/api/ApiEventOpsScene'
import { PageProps, initPage } from 'src/utils/interface'
import { useCopyToClipboard } from 'react-use'

interface VersionDrawerProps {
  className?: string
  visible: boolean
  record: SceneRecordItemProp
  onClose: () => void
}

const VersionDrawer: React.FC<VersionDrawerProps> = ({ className, record, visible, onClose }) => {
  const history = useHistory()
  const [page, setPage] = useState<PageProps>(initPage)
  // 复制
  const [, copyToClipboard] = useCopyToClipboard()
  const { value: versionList } = useAsync(async () => {
    if (visible && record?.Sign) {
      const result = await getSceneList({
        Sign: record?.Sign,
        Limit: page.PageSize,
        Offset: (page.Page - 1) * page.PageSize
      })
      return result
    } else {
      setPage(initPage)
      return {
        Info: [],
        Total: 0
      }
    }
  }, [visible, page])

  return (
    <div id="version-page" className={className}>
      <Drawer
        value={visible}
        width={1000}
        title="版本"
        container={() => document.getElementById('version-page')}
        onChangeValue={show => {
          if (!show) {
            onClose()
          }
        }}
        slotFooter={
          <Button
            onClick={() => {
              onClose()
            }}
          >
            关闭
          </Button>
        }
      >
        <>
          <Table
            data={versionList?.Info || []}
            animation={false}
            rowKey={record => record?.ID || record?.Sign}
            checkType="none"
          >
            <TableColumn key="ID" title="ID" width="50" />
            <TableColumn
              key="Creator"
              title="操作人"
              width="120"
              slotTemplate={([{ Creator }]) => {
                return <UserInfo name={Creator} />
              }}
            />
            <TableColumn
              key="CreatedAt"
              title="创建时间"
              slotTemplate={([{ CreatedAt }]) => {
                return CreatedAt ? dayjs(CreatedAt).format('YYYY-MM-DD HH:mm:ss') : '-'
              }}
            />
            <TableColumn
              key="Version"
              title="版本"
              width="80"
              slotTemplate={([{ Version }]) => {
                return Version ? Version : '-'
              }}
            />
            <TableColumn
              key="VersionRemark"
              title="版本说明"
              slotTemplate={([{ VersionRemark }]) => {
                return VersionRemark ? VersionRemark : '-'
              }}
            />
            <TableColumn
              key="Status"
              title="状态"
              fixed="right"
              width="100"
              slotTemplate={([{ Status }]) => {
                return getStatus(Status)
              }}
            />
            <TableColumn
              key="operations"
              title="操作"
              fixed="right"
              width="90"
              slotTemplate={([record]) => {
                return (
                  <div className="ksc-space">
                    <a
                      onClick={() => {
                        history.push(`/monitor/eventops/scene/detail/${record.ID}`)
                      }}
                    >
                      查看
                    </a>
                    <a
                      onClick={async () => {
                        const copyResult = await copyScene(record.ID)
                        if (copyResult) {
                          copyToClipboard(JSON.stringify(copyResult))
                          Message.success('已复制到粘贴板，请点击【新增场景】按钮去导入')
                        }
                      }}
                    >
                      复制
                    </a>
                  </div>
                )
              }}
            />
          </Table>
          <Pagination
            value={page.Page}
            limit={page.PageSize}
            size="small"
            total={versionList?.Total || 0}
            onChangeValue={value => {
              setPage({
                ...page,
                Page: value
              })
            }}
            onChangeLimit={limit => {
              setPage({
                ...page,
                PageSize: limit
              })
            }}
          />
        </>
      </Drawer>
    </div>
  )
}

export default styled(VersionDrawer)`
  .k-dialog-wrapper {
    z-index: 9998;
  }
`
